// ============================================================
// subscriptionModal.js — Modal elegante de activación de prueba / suscripción
// ============================================================

let activeModalOverlay = null;

/**
 * Muestra el modal de activación de prueba o suscripción requerida.
 * @param {Object} options
 * @param {string} [options.title] - Título del modal
 * @param {string} [options.message] - Mensaje explicativo
 * @param {string} [options.redirectUrl] - URL a la que redirigir si pulsa suscribirse ('precios.html')
 */
export function showSubscriptionModal(options = {}) {
  // Si ya hay un modal abierto, cerrarlo antes
  if (activeModalOverlay) {
    activeModalOverlay.remove();
    activeModalOverlay = null;
  }

  const title = options.title || '¡Activa tu Período de Prueba!';
  const message = options.message || 'Para comenzar a generar imágenes, vídeos y avatares con IA, activa tu prueba gratuita o suscríbete a un plan.';
  const redirectUrl = options.redirectUrl || 'precios.html';

  // Crear el contenedor del modal
  const overlay = document.createElement('div');
  overlay.className = 'vimo-sub-modal-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');

  overlay.innerHTML = `
    <div class="vimo-sub-modal-card">
      <button type="button" class="vimo-sub-modal-close" aria-label="Cerrar modal">&times;</button>
      <div class="vimo-sub-modal-header">
        <div class="vimo-sub-modal-icon">
          ✨
        </div>
        <h3 class="vimo-sub-modal-title">${escapeHtml(title)}</h3>
      </div>
      <div class="vimo-sub-modal-body">
        <p>${escapeHtml(message)}</p>
      </div>
      <div class="vimo-sub-modal-actions">
        <button type="button" class="vimo-sub-btn vimo-sub-btn-secondary" id="vimoSubModalCloseBtn">
          Más tarde
        </button>
        <a href="${redirectUrl}" class="vimo-sub-btn vimo-sub-btn-primary" id="vimoSubModalGoBtn">
          Ver Planes y Suscribirme 🚀
        </a>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);
  activeModalOverlay = overlay;

  // Animación de entrada
  requestAnimationFrame(() => {
    overlay.classList.add('is-visible');
  });

  // Event Listeners
  const closeBtn = overlay.querySelector('.vimo-sub-modal-close');
  const cancelBtn = overlay.querySelector('#vimoSubModalCloseBtn');

  const closeModal = () => {
    overlay.classList.remove('is-visible');
    setTimeout(() => {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (activeModalOverlay === overlay) activeModalOverlay = null;
    }, 250);
  };

  closeBtn?.addEventListener('click', closeModal);
  cancelBtn?.addEventListener('click', closeModal);

  // Cerrar haciendo clic fuera del modal
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeModal();
    }
  });

  // Escape key
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModal();
      document.removeEventListener('keydown', handleKeyDown);
    }
  };
  document.addEventListener('keydown', handleKeyDown);
}

function escapeHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
